import { Loader2 } from "lucide-react";

export function LoadingSpinner({ className = "", size = 24 }: { className?: string; size?: number }) {
    return (
        <div className={`flex items-center justify-center ${className}`}>
            <Loader2 className="animate-spin text-primary" size={size} />
        </div>
    );
}

export function PageLoading() {
    return (
        <div className="h-[50vh] w-full flex items-center justify-center">
            <div className="flex flex-col items-center gap-4">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
                <p className="text-muted-foreground text-sm font-medium">Loading...</p>
            </div>
        </div>
    );
}
